
import { Component, Vue, Prop } from "vue-property-decorator";
import { QuestMapPoi } from "@/models/MapPois/Quest/QuestMapPoi";

@Component
class ComposeQuestMapTable extends Vue {
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  searchFilter = "";
  busy = false;
  currentPage = 1;
  perPage = 5;
  fields = [
    {
      key: "title",
      label: "Title",
      sortable: true,
    },
    {
      key: "type",
      label: "Type",
      sortable: true,
    },
    {
      key: "mapStatus",
      label: "Map Status?",
      sortable: true,
    },
    {
      key: "content",
      label: "CGs?",
      sortable: true,
    },
    {
      key: "exitGoals",
      label: "Goals",
      sortable: true,
    },
    {
      key: "action",
      label: "Actions",
      sortable: true,
    },
    {
      key: "valid",
      label: "Valid",
      sortable: true,
    },
  ];
  get getMapPoiData(): QuestMapPoi[] {
    return this.$store.state.mapPoiStore.questMapPoi;
  }

  getContentGroups(item: any): number {
    if (item.title.en === "START_ZONE") {
      return 0;
    } else {
      return Object.keys(item.contentGroups).length;
    }
  }

  getActionCount(item: any): number {
    if (item.title.en === "START_ZONE") {
      return 0;
    } else {
      var actionCount = 0;
      var contentGroups = Object.values(item.contentGroups);
      contentGroups.forEach((x: any) => {
        if (x.d1.actions !== undefined) {
          actionCount += Object.keys(x.d1.actions).length;
        }
        if (x.d2 !== undefined && x.d2.actions !== undefined) {
          actionCount += Object.keys(x.d2.actions).length;
        }
      });
      return actionCount;
    }
  }
  getExitCount(item: any): number {
    if (item.title.en === "START_ZONE") {
      return 0;
    } else {
      var actionCount = 0;
      var contentGroups = Object.values(item.contentGroups);
      contentGroups.forEach((x: any) => {
        if (x.exitGoals !== undefined) {
          actionCount += Object.keys(x.exitGoals).length;
        }
      });
      return actionCount;
    }
  }
  getRowCssClass(item: any): string {
    if (!this.getIsValid(item)) {
      return "highlight-row";
    } else if (item.issues !== undefined && item.issues.err !== undefined) {
      return "highlight-row";
    } else {
      return "";
    }
  }
  getIsValid(item: any): boolean {
    if (
      item.loc.loc_uid.trim().length == 0 &&
      (item.loc.override_ll.latitude == 0 ||
        item.loc.override_ll.longitude == 0)
    ) {
      return false;
    } else {
      return true;
    }
  }

  filterByTitleName(row: any) {
    if (row.title.en.toLowerCase().includes(this.searchFilter.toLowerCase())) {
      return true;
    }
    return false;
  }

  onRowSelected(rows: any): void {
    //I'm not sure what type this should be. I have called any for the time being
    let myTable = this.$refs.composeTable as any;
    myTable.clearSelected();
    this.$emit("handleTableSelection", rows[0]);
  }
}

export default ComposeQuestMapTable;
